import { render, staticRenderFns } from "./certificateInfo_new.vue?vue&type=template&id=47edbf5e&scoped=true"
import script from "./certificateInfo_new.vue?vue&type=script&lang=js"
export * from "./certificateInfo_new.vue?vue&type=script&lang=js"
import style0 from "./certificateInfo_new.vue?vue&type=style&index=0&id=47edbf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edbf5e",
  null
  
)

export default component.exports